import React, { Suspense } from 'react'

import StyledAdminWrapper from './StyledAdminWrapper'
import GCRefundMetricsEntry from 'components_v2/Admin/GCRefundMetrics/GCRefundMetricsEntry'

const GCRefundWrapper = () => (
  <StyledAdminWrapper>
    <Suspense fallback=''>
      <GCRefundMetricsEntry />
    </Suspense>
  </StyledAdminWrapper>
)

export default GCRefundWrapper
